import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/common/Button';

export function NotFoundPage(): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center min-h-full gap-6 py-20 text-center animate-fade-in">
      <div className="text-8xl font-black gradient-text">404</div>
      <div>
        <h2 className="text-xl font-semibold text-white">Page not found</h2>
        <p className="mt-2 text-sm text-slate-500 max-w-sm">
          The page you're looking for doesn't exist or has been moved.
        </p>
      </div>
      <Link to="/dashboard">
        <Button variant="primary">Go to Dashboard</Button>
      </Link>
    </div>
  );
}
